import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import Tile from '../Tile';
import Link from '../Link';
import RatingMark from '../RatingMark';
import { Root } from './styles';
import { DateBlock, Desc, Img, Info, Text, Title, Top } from '../Tile/styles';
// import FavoriteBtn from '../FavoriteBtn';

import brokenImageThumb from '../../../public/images/errors/broken-image-480.png';

const renderContent = (data, label, url) =>
	data.map((item) => {
		const rating = item.rating ? parseFloat(item.rating).toFixed(1) : 0;
		const image =
			item.type === 'analytics' ||
			item.type === 'buyer' ||
			item.type === 'tenant' ||
			item.type === 'mystery_buyer' ||
			item.type === 'mystery_tenant'
				? item.previewPicture
				: item.preview_image;
		const link =
			item.type === 'analytics' ||
			item.type === 'buyer' ||
			item.type === 'tenant' ||
			item.type === 'mystery_buyer' ||
			item.type === 'mystery_tenant'
				? item.slug
				: item.code;
		const category = url ? `${url}/` : ``;

		return (
			<Tile key={item.id.toString()} type={item.tileType ?? 'normal'}>
				{/* {!item.objectType || (item.objectType && item.objectType !== 'title') ? ( */}
				{/* <FavoriteBtn id={item.id} type={item.type} /> */}
				{/* ) : null} */}
				<Link to={link && `${category}${link}/`}>
					<LazyLoad height="100%" offset={200} once>
						<Img $type={item.tileType || 'normal'}>
							{image && (
								<img
									src={image}
									alt={item.title}
									onError={(e) => {
										e.target.onerror = null;
										e.target.src = brokenImageThumb;
									}}
								/>
							)}
							{!!item.rating && <RatingMark value={Number(rating)} type="sector-bottom-left" />}
						</Img>
					</LazyLoad>

					<Info $type={item.tileType || 'normal'} $isTitle={item.objectType && item.objectType === 'title'}>
						<Top>
							{item.active_from && (
								<DateBlock>
									<time dateTime={new Date(item.active_from).toISOString()}>
										{new Date(item.active_from).toLocaleString('ru-RU',{
											day: 'numeric',
											month: 'long',
										})}
									</time>
								</DateBlock>
							)}
						</Top>

						{item.title && <Title>{item.title}</Title>}

						<Desc>
							{label !== 'Исследования' &&
								label !== 'Тайный покупатель' &&
								label !== 'Тайный жилец' &&
								item.preview_desc &&
								item.preview_desc}
						</Desc>

						{item.tileType && item.tileType !== 'normal' ? <Text>{item.text}</Text> : null}
					</Info>
				</Link>
			</Tile>
		);
	});

const TilesObjects = ({ data, label, url }) => <Root>{renderContent(data, label, url)}</Root>;

TilesObjects.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TilesObjects;
